// extracted by mini-css-extract-plugin
export default {"headWrapper":"styles_headWrapper__XTf3q","posterWrap":"styles_posterWrap__OWImC","poster":"styles_poster__7nSV+"};